import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export type ReasonContext = 'settings' | 'actual' | 'add' | 'exclude' | 'postpone' | 'cancel' | 'correct';
const REASONS: Record<ReasonContext, string[]> = {
  settings: ['開催日時の変更', '回答期限・受付時刻の変更', '対象組織・役職の見直し', '会議成立条件の変更', '設定の誤りを訂正'],
  actual: ['本人からの申し出', '出席登録忘れの代理登録', '欠席を確認', '登録の誤りを訂正'],
  add: ['対象者の漏れを補完', '代理出席者を追加', '役職・所属の変更に対応'],
  exclude: ['対象外の人を訂正', '重複・誤追加を訂正', '異動・退任に対応'],
  postpone: ['開催日程の再調整', '会場・設備の都合', '講師・出席予定者の都合', '天候・災害・交通機関の影響', '組合・業務上の都合'],
  cancel: ['参加見込み人数の不足', '企画内容・開催方針の見直し', '会場・講師等の確保が困難', '天候・災害等による安全上の判断', '組合・業務上の都合'],
  correct: ['出席・欠席の登録誤りを訂正', '対象者の追加・除外漏れを訂正', '登録の誤りを訂正'],
};

@Component({
  selector: 'app-attendance-reason-input', standalone: true, imports: [FormsModule],
  template: `
    <label>{{ label }}<select [attr.aria-label]="label" [disabled]="disabled" [(ngModel)]="selection" (ngModelChange)="emitValue()">
      <option value="">選択してください</option>
      @for (option of options; track option) { <option [value]="option">{{ option }}</option> }
      <option value="その他">その他</option>
    </select></label>
    @if (selection) {
      <label class="detail">{{ selection === 'その他' ? '具体的な理由（必須）' : '補足（任意）' }}
        <textarea [disabled]="disabled" [(ngModel)]="detail" (ngModelChange)="emitValue()" maxlength="440" rows="2"></textarea>
      </label>
    }
  `,
  styles: [`:host{display:block;margin:16px 0}label{display:grid;gap:8px;font-size:14px}select,textarea{box-sizing:border-box;width:100%;padding:10px;border:1px solid #bcc8d8;border-radius:5px;font:inherit;background:white}textarea{resize:vertical}.detail{margin-top:12px;color:#667085}`],
})
export class AttendanceReasonInputComponent implements OnChanges {
  @Input() context: ReasonContext = 'settings';
  @Input() label = '変更理由';
  @Input() value = '';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();
  selection = '';
  detail = '';
  private lastEmitted = '';
  get options(): string[] { return REASONS[this.context]; }
  ngOnChanges(): void {
    if (!this.value && this.lastEmitted) { this.selection = ''; this.detail = ''; this.lastEmitted = ''; }
  }
  emitValue(): void {
    const detail = this.detail.trim();
    this.lastEmitted = !this.selection || (this.selection === 'その他' && !detail)
      ? '' : this.selection + (detail ? '：' + detail : '');
    this.valueChange.emit(this.lastEmitted);
  }
}
